export default __webpack_public_path__ + "static/media/ice.c91ee116.jpg";